import * as rest from './RestUtil';
import { getFunctionBaseUrl } from './RestUrls';
import { IInfoTextDetails } from '../util/DataModelInterface';
import * as storage from '../util/StorageUtil';

export const getInfotexts = async (force: boolean = false) => {
  let infotexts = storage.getInfotexts();
  if (!infotexts || force) {
    const url = `${getFunctionBaseUrl()}/api/getInfotexts`;
    const response = await rest.get(url);
    if(response && response.result) {
      storage.setInfotexts(response.result);
      infotexts = response.result;
    } else {
      return response;
    }
  }
  return infotexts;
}

export const getWelcomeText = async () => {
  let welcome = {};
  const url = `${getFunctionBaseUrl()}/api/getInfotexts/welcome`;
  const response = await rest.get(url);
  if(response && response.result) {
      storage.setInfotexts(response.result);
      welcome = response.result;
  } else {
    return response;
  }
  return welcome;
}

export const modifyInfotext = async (message: IInfoTextDetails) => {
  const url = `${getFunctionBaseUrl()}/api/modifyInfotext/`;
  const response = await rest.post(url, message);
  // console.log("resp: ", response);
  return response;
}
